export default __webpack_public_path__ + "static/media/tweet.0b531970.svg";